import { gql } from "graphql-tag"
import { fetchGQL } from "app/api"
import {
  CustomerAccountDeactivateMutation,
  CustomerAccountDeactivateMutationVariables,
} from "generated/graphql"

const CUSTOMER_ACCOUNT_DEACTIVATE = gql`
  mutation customerAccountDeactivate($in: CustomerAccountDeactivateInput!) {
    customerAccountDeactivate(in: $in)
  }
`

export const fetchCustomerAccountDeactivate = async (
  customerId: number
): Promise<CustomerAccountDeactivateMutation | undefined> => {
  const variables: CustomerAccountDeactivateMutationVariables = {
    in: {
      customerId,
    },
  }
  const data = await fetchGQL<
    CustomerAccountDeactivateMutation,
    CustomerAccountDeactivateMutationVariables
  >(CUSTOMER_ACCOUNT_DEACTIVATE, variables)
  return data
}
